import { Fragment } from "react";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Skeleton } from "@mui/material";
import classes from "../TableBody/TableBody.module.css";

const TableRow = ({
  dad,
  index,
  isProcessual,
  hideSelectedData,
  rowClickable,
  density,
  selectedRows,
  selectable,
  customChecked,
  currentPage,
  dataLimit,
  renderCells,
  view,
  canDelete,
  canEdit,
  canViewForm,
  canInsertEdition,
  forceLtr,
  userLanguage,
  isLoading,
  rowClickHandler,
  changeSelectedRowsHandler,
  viewButtonHandler,
  editButtonHandler,
  insertEditionButtonHandler,
  onRequestDelete, // جایگزین targetedDataForDelete/targetedDataEventForDelete
}) => {
  const properData = isProcessual ? dad[0] : dad;

  const eyeBtnDensityClass =
    density === "normal"
      ? classes.normalEyeBtn
      : density === "compact"
        ? classes.compactEyeBtn
        : density === "large"
          ? classes.largeEyeBtn
          : null;

  const rowHeightClass =
    density === "normal"
      ? classes.normalHeight
      : density === "compact"
        ? classes.compactHeight
        : density === "large"
          ? classes.largeHeight
          : null;

  if (hideSelectedData[properData.id]) return null;

  return (
    <tr
      className={[
        classes.row,
        rowClickable ? classes.pointerCursor : "",
        rowHeightClass,
        selectedRows?.map((each) => each.id)?.includes(properData.id) ? classes.selectedRow : null,
      ].join(" ")}
      onClick={() => rowClickHandler(properData)}
    >
      {selectable ? (
        <td className={classes.tdCheckbox}>
          <input
            className={classes.selectInput}
            type="checkbox"
            id={`select-${properData.id}`}
            name="selectAll"
            onClick={(e) => e.stopPropagation()}
            onChange={() => changeSelectedRowsHandler(properData)}
            checked={
              customChecked
                ? customChecked(properData)
                : selectedRows?.map((each) => each.id)?.includes(properData.id)
            }
          />
        </td>
      ) : null}

      <td className={classes.tdRecord}>{index + 1 + (currentPage - 1) * dataLimit}</td>

      {renderCells(properData)}

      {view ? null : (
        <td className={classes.actionsContainer}>
          {!canDelete && !canEdit && !canViewForm ? null : (
            <span
              className={[
                classes.actionsSpan,
                forceLtr || userLanguage === "en" ? classes.ltrActionsSpan : classes.rtlActionsSpan,
                selectable ? classes.selectableActionsSpan : classes.unSelectableActionsSpan,
              ].join(" ")}
            >
              {canViewForm ? (
                <span
                  className={[classes.showInfosBtn, eyeBtnDensityClass].join(" ")}
                  onClick={(e) => {
                    e.stopPropagation();
                    viewButtonHandler(properData);
                  }}
                >
                  <VisibilityIcon className={classes.editIcon} />
                </span>
              ) : null}

              {!canDelete ? null : (
                <span
                  className={[classes.showInfosBtn, eyeBtnDensityClass].join(" ")}
                  onClick={(e) => {
                    onRequestDelete(e, isProcessual ? properData : dad);
                  }}
                >
                  <DeleteOutlineOutlinedIcon className={classes.phisicalDeleteIcon} />
                </span>
              )}

              {canEdit && !(isProcessual && !dad[1]) ? (
                <span
                  className={[classes.showInfosBtn, eyeBtnDensityClass].join(" ")}
                  onClick={(e) => {
                    e.stopPropagation();
                    editButtonHandler(properData);
                  }}
                >
                  <SettingsOutlinedIcon className={classes.editIcon} />
                </span>
              ) : null}

              {canEdit && canInsertEdition && dad[0].stateEnglishName === "Accepted" ? (
                <span
                  className={[classes.showInfosBtn, eyeBtnDensityClass].join(" ")}
                  onClick={(e) => {
                    e.stopPropagation();
                    insertEditionButtonHandler(properData);
                  }}
                >
                  <EditOutlinedIcon className={classes.editIcon} />
                </span>
              ) : null}
            </span>
          )}
        </td>
      )}

      {isLoading ? (
        <td className={[classes.newSkeletonTd, rowHeightClass].join(" ")}>
          <span className={classes.newSkeletonSpanContainer}>
            <Skeleton animation="wave" className={classes.newSkeleton} />
          </span>
        </td>
      ) : null}
    </tr>
  );
};

export default TableRow;
